import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { fetchProducts } from './productSlice';
import ProductCard from '../../components/ProductCard';
import MarketplaceNavbar from '../../components/MarketplaceNavbar'
import "./ProductList.css"
import { FaFilter } from "react-icons/fa";
import {
  specialization,
  languages,
  ChargesPerPerformance,
  artInfo1,
  indian_cities,
} from "../Data/artistProfile";
import { makeAuthenticatedGETRequest, makeUnauthenticatedGETRequest } from '../services/serverHelper';
import { productPoints } from '../services/apis';
import { toast, ToastContainer } from "react-toastify";
import { addToCart } from '../reducer/slices/cartSlice';

export const purpose = [
            {
              "category": "Devotional & Spiritual Arts",
              "subcategories": [
                {
                  "name": "Devotional Music",
                  "artForms": [
                    "Bhajan",
                    "Kirtan",
                    "Qawwali",
                    "Abhang",
                    "Shabad Kirtan",
                    "Sufi Music",
                    "Namasankeertanam"
                  ]
                },
                {
                  "name": "Devotional Dance",
                  "artForms": [
                    "Odissi",
                    "Kathak (Temple Tradition)",
                    "Sattriya",
                    "Mohiniyattam"
                  ]
                },
                {
                  "name": "Religious Visual Arts",
                  "artForms": [
                    "Pattachitra",
                    "Temple Murals",
                    "Tanjore Painting",
                    "Madhubani (Religious Themes)"
                  ]
                }
              ]
            },
            {
              "category": "Classical Arts",
              "subcategories": [
                {
                  "name": "Classical Dance",
                  "artForms": [
                    "Bharatanatyam",
                    "Kathak",
                    "Odissi",
                    "Kuchipudi",
                    "Kathakali",
                    "Mohiniyattam",
                    "Manipuri",
                    "Sattriya"
                  ]
                },
                {
                  "name": "Classical Music",
                  "artForms": [
                    "Carnatic Vocal",
                    "Hindustani Vocal",
                    "Dhrupad",
                    "Khayal",
                    "Thumri",
                    "Tarana"
                  ]
                },
                {
                  "name": "Classical Instruments",
                  "artForms": [
                    "Sitar",
                    "Sarod",
                    "Veena",
                    "Santoor",
                    "Tabla",
                    "Mridangam",
                    "Flute",
                    "Violin"
                  ]
                }
              ]
            },
            {
              "category": "Folk Arts",
              "subcategories": [
                {
                  "name": "Folk Dance",
                  "artForms": [
                    "Lavani",
                    "Garba",
                    "Dandiya",
                    "Bihu",
                    "Ghoomar",
                    "Kalbelia",
                    "Kummi",
                    "Karagattam",
                    "Bhangra",
                    "Giddha",
                    "Rouf",
                    "Dollu Kunitha"
                  ]
                },
                {
                  "name": "Folk Music",
                  "artForms": [
                    "Baul",
                    "Manganiyar Music",
                    "Langa Music",
                    "Pandavani",
                    "Bhatiali",
                    "Lok Geet",
                    "Folk Drumming"
                  ]
                },
                {
                  "name": "Folk Theatre",
                  "artForms": [
                    "Tamasha",
                    "Bhavai",
                    "Jatra",
                    "Nautanki",
                    "Yakshagana",
                    "Therukoothu",
                    "Bhand Pather"
                  ]
                }
              ]
            },
            {
              "category": "Tribal Arts",
              "subcategories": [
                {
                  "name": "Tribal Painting",
                  "artForms": [
                    "Warli",
                    "Gond Art",
                    "Bhil Art",
                    "Saura Art",
                    "Pithora Art"
                  ]
                },
                {
                  "name": "Tribal Dance",
                  "artForms": [
                    "Santhal Dance",
                    "Gaur Dance",
                    "Karma Dance",
                    "Dhemsa",
                    "Ho Dance"
                  ]
                },
                {
                  "name": "Tribal Music",
                  "artForms": [
                    "Tribal Percussion",
                    "Indigenous Folk Singing",
                    "Traditional Tribal Instruments"
                  ]
                }
              ]
            },
            {
              "category": "Performing Arts",
              "subcategories": [
                {
                  "name": "Dance Performance",
                  "artForms": [
                    "Solo Dance",
                    "Group Dance",
                    "Dance Drama"
                  ]
                },
                {
                  "name": "Music Performance",
                  "artForms": [
                    "Solo Vocal",
                    "Choir",
                    "Instrumental Ensemble",
                    "Fusion Band"
                  ]
                },
                {
                  "name": "Theatre",
                  "artForms": [
                    "Traditional Theatre",
                    "Street Theatre",
                    "Mime",
                    "Musical Theatre"
                  ]
                }
              ]
            },
            {
              "category": "Visual Arts",
              "subcategories": [
                {
                  "name": "Traditional Paintings",
                  "artForms": [
                    "Madhubani",
                    "Pattachitra",
                    "Kalamkari",
                    "Miniature Painting",
                    "Tanjore Painting",
                    "Phad Painting",
                    "Cheriyal Scroll Painting"
                  ]
                },
                {
                  "name": "Drawing & Illustration",
                  "artForms": [
                    "Traditional Illustration",
                    "Scroll Art",
                    "Folk Illustration"
                  ]
                },
                {
                  "name": "Murals",
                  "artForms": [
                    "Temple Murals",
                    "Wall Murals",
                    "Contemporary Folk Murals"
                  ]
                }
              ]
            },
            // {
            //   "category": "Crafts & Handicrafts",
            //   "subcategories": [
            //     {
            //       "name": "Wood Crafts",
            //       "artForms": [
            //         "Wood Carving",
            //         "Wood Inlay",
            //         "Furniture Craft"
            //       ]
            //     },
            //     {
            //       "name": "Metal Crafts",
            //       "artForms": [
            //         "Dhokra",
            //         "Brass Craft",
            //         "Bell Metal Craft",
            //         "Bidriware"
            //       ]
            //     },
            //     {
            //       "name": "Pottery & Terracotta",
            //       "artForms": [
            //         "Terracotta",
            //         "Blue Pottery",
            //         "Ceramic Pottery"
            //       ]
            //     },
            //     {
            //       "name": "Natural Material Crafts",
            //       "artForms": [
            //         "Bamboo Craft",
            //         "Cane Craft",
            //         "Jute Craft",
            //         "Coir Craft"
            //       ]
            //     }
            //   ]
            // },
            // {
            //   "category": "Textile & Weaving Arts",
            //   "subcategories": [
            //     {
            //       "name": "Handloom Weaving",
            //       "artForms": [
            //         "Banarasi Weaving",
            //         "Kanchipuram Silk",
            //         "Pochampally Ikat",
            //         "Paithani",
            //         "Patola",
            //         "Chanderi"
            //       ]
            //     },
            //     {
            //       "name": "Embroidery",
            //       "artForms": [
            //         "Chikankari",
            //         "Phulkari",
            //         "Kantha",
            //         "Kasuti",
            //         "Zardozi"
            //       ]
            //     },
            //     {
            //       "name": "Textile Dyeing",
            //       "artForms": [
            //         "Bandhani",
            //         "Leheriya",
            //         "Ajrakh",
            //         "Kalamkari Textile"
            //       ]
            //     }
            //   ]
            // },
            {
              "category": "Literary & Storytelling Arts",
              "subcategories": [
                {
                  "name": "Oral Storytelling",
                  "artForms": [
                    "Harikatha",
                    "Dastangoi",
                    "Pandavani",
                    "Kavad Storytelling",
                    "Burrakatha",
                    "Pala"
                  ]
                },
                {
                  "name": "Poetry & Recitation",
                  "artForms": [
                    "Kavi Sammelan",
                    "Urdu Mushaira",
                    "Folk Poetry"
                  ]
                }
              ]
            },
            // {
            //   "category": "Martial & Heritage Arts",
            //   "subcategories": [
            //     {
            //       "name": "Traditional Martial Arts",
            //       "artForms": [
            //         "Kalaripayattu",
            //         "Gatka",
            //         "Silambam",
            //         "Thang-Ta",
            //         "Mardani Khel"
            //       ]
            //     },
            //     {
            //       "name": "Weapon Demonstrations",
            //       "artForms": [
            //         "Sword Performance",
            //         "Stick Fighting",
            //         "Traditional Combat Displays"
            //       ]
            //     }
            //   ]
            // },
            {
              "category": "Festival & Event Arts",
              "subcategories": [
                {
                  "name": "Festival Performances",
                  "artForms": [
                    "Garba",
                    "Dandiya",
                    "Dhol-Tasha",
                    "Bhangra",
                    "Chhau"
                  ]
                },
                {
                  "name": "Procession Arts",
                  "artForms": [
                    "Traditional Drumming",
                    "Cultural Processions",
                    "Religious Processions"
                  ]
                }
              ]
            },
            {
              "category": "Contemporary Fusion Arts",
              "subcategories": [
                {
                  "name": "Fusion Music",
                  "artForms": [
                    "Classical Fusion",
                    "Folk Fusion",
                    "Indie Folk"
                  ]
                },
                {
                  "name": "Fusion Dance",
                  "artForms": [
                    "Contemporary Kathak",
                    "Contemporary Bharatanatyam",
                    "Experimental Folk Dance"
                  ]
                },
                {
                  "name": "Modern Visual Arts",
                  "artForms": [
                    "Modern Tribal Art",
                    "Contemporary Folk Art",
                    "Digital Heritage Art"
                  ]
                }
              ]
            },
            // {
            //   "category": "Educational & Heritage Arts",
            //   "subcategories": [
            //     {
            //       "name": "Workshops",
            //       "artForms": [
            //         "Painting Workshops",
            //         "Craft Workshops",
            //         "Music Workshops",
            //         "Dance Workshops"
            //       ]
            //     },
            //     {
            //       "name": "Heritage Demonstrations",
            //       "artForms": [
            //         "Museum Demonstrations",
            //         "Live Craft Demonstrations",
            //         "Cultural Interpretation Programs"
            //       ]
            //     },
            //     {
            //       "name": "Training Programs",
            //       "artForms": [
            //         "Guru-Shishya Training",
            //         "Apprenticeship Programs",
            //         "Skill Preservation Programs"
            //       ]
            //     }
            //   ]
            // }
  ] 


const ProductList = () => {
  const dispatch = useDispatch();
  const {selectCartItems} = useSelector(state => state.cart.cartItems);
  const [orders, setOrders] = useState([])
  const { products, loading, error } = useSelector((state) => state.products);
  const [art, setArt] = useState(undefined);
  const [indx, setIndx] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams({});
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const {accessToken} = useSelector(state => state.auth);
  const [data, setData] = useState([])
  const itemsPerPage = 10;

  const [selectedCategoryName, setSelectedCategoryName] = useState('');
  const [selectedSubcategoryName, setSelectedSubcategoryName] = useState('');
  const [selectedArtForm, setSelectedArtForm] = useState('');
  const [selectedBudget, setSelectedBudget] = useState('');
  const [selectedLanguage, setSelectedLanguage] = useState('');

  // 2. Find the object for the currently selected category
  const currentCategoryObj = purpose.find(
    (item) => item.category === selectedCategoryName
  );

  // 3. Find the object for the currently selected subcategory
  const currentSubcategoryObj = currentCategoryObj?.subcategories.find(
    (sub) => sub.name === selectedSubcategoryName
  );

  // 4. Handle parent changes (reset children states to avoid bugs)
  const handleCategoryChange = (e) => {
    const val = e.target.value;
    setSelectedCategoryName(val);
    setSelectedSubcategoryName(''); // Reset subcategory
    setSelectedArtForm('');         // Reset art form
    updateFilter({ category: val, subcategory: '', artform: '' });
  };

  const handleSubcategoryChange = (e) => {
    const val = e.target.value;
    setSelectedSubcategoryName(val);
    setSelectedArtForm('');         // Reset art form
    updateFilter({ subcategory: val, artform: '' });
  };

  const handleBudgetChange = (e) => {
    const val = e.target.value;
    setSelectedBudget(val);
    updateFilter({ budget: val });
  };

  const handleLanguageChange = (e) => {
    const val = e.target.value;
    setSelectedLanguage(val);
    updateFilter({ language: val });
  };
  
  useEffect(() => {
    fetchProducts();
    if(accessToken){
      fetchCartItems();
    }
  }, []);

  const fetchCartItems = async()=>{
    try {
          const response = await makeAuthenticatedGETRequest( 
            `${productPoints.GET_CART_ITEM}/${localStorage.getItem('artId')}`,
            accessToken
          );
          console.log(response.data.cart)
          if(response.statusCode === 200){
            console.log(selectCartItems);
            dispatch(addToCart(response.data.cart));
          }else{
            toast.error("Product not Fetched to cart.")
          }
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
  };

  const fetchProducts = async() => {
    try {
      if(!accessToken){
        const response = await makeUnauthenticatedGETRequest(
          `${productPoints.FETCH_PUBLIC_PRODUCTS_API}`
        );
        setOrders(response.data.products);
        setData(response.data.products); 
        console.log(response.data);
      }else{
        const response = await makeAuthenticatedGETRequest(
            `${productPoints.FETCH_PUBLIC_PRODUCTS_API}?userid=${localStorage.getItem('artId')}`,
            accessToken
          );
          setOrders(response.data.orders);
          const removeOrderedProducts = response.data.products.filter(item => !response.data.orders.some(order => order.productId.toString() === item._id.toString() && (order.payment.paymentStatus === 'Verified' || order.payment.paymentStatus === 'pending')));
          console.log(removeOrderedProducts);
          setData(removeOrderedProducts); 
          console.log(response.data);
      }
    } catch (error) {
      
    }

  }

  const currentPage = Number(searchParams.get('page')) || 1;
  
  const updateFilter = (changes) => {
    const params = new URLSearchParams(searchParams.toString());

    Object.entries(changes).forEach(([key, value]) => {
      if (value) params.set(key, value);
      else params.delete(key);
    });

    if (!Object.prototype.hasOwnProperty.call(changes, 'page')) {
      params.set('page', '1');
    }

    setSearchParams(params);
  };
  
  const updatePage = (increment) => {
    const params = new URLSearchParams(searchParams.toString());
    const current = Number(params.get('page')) || 1;
    const nextPage = current + increment;

    params.set('page', nextPage.toString());
    console.log("currentPage state:", currentPage);
    console.log("URL page:", searchParams.get('page'));
    setSearchParams(params);
  };

  const filteredData = useMemo(() => {
      if (!data) return [];
  
      // Extract params once inside the memo
      const params = {
        category: searchParams.get('category')?.toLowerCase(),
        subcategory: searchParams.get('subcategory')?.toLowerCase(),
        artform: searchParams.get('artform')?.toLowerCase(),
        budget: searchParams.get('budget')?.toLowerCase(),
        language: searchParams.get('language')?.toLowerCase(),
      };

      const matches = (field, param) => !param || field?.toLowerCase().includes(param);

      const matchesArray = (value, param) => {
        if (!param) return true;
        if (!value) return false;
        if (Array.isArray(value)) {
          return value.some(a => a && a.toLowerCase().includes(param));
        }
        return String(value).toLowerCase().includes(param);
      };

      let filteredProfiles = data.filter(profile => {
        const matchCategory = !params.category || (
          profile.title?.toLowerCase().includes(params.category)
        );

        const matchSubcategory = !params.subcategory || (
          profile.category?.toLowerCase().includes(params.subcategory)
        );

        const matchArtForm = !params.artform || (
          profile.subCategory?.toLowerCase().includes(params.artform)
        );

        const matchBudget = !params.budget || (() => {
          if (!profile.pricing || !profile.pricing.amount) return false;
          const amount = parseInt(profile.pricing.amount, 10);
          if (params.budget === '5000+') {
            return amount >= 5000;
          }
          const [min, max] = params.budget.split('-').map(v => parseInt(v, 10));
          if (!Number.isFinite(min) || !Number.isFinite(max)) return false;
          return amount >= min && amount <= max;
        })();

        const matchLanguage = !params.language || matchesArray(profile.language, params.language);

        return matchCategory && matchSubcategory && matchArtForm && matchBudget && matchLanguage;
      });

      return filteredProfiles;
    }, [
      data, 
      searchParams.toString() // Depend on the string representation of URL params
    ]);

  //Index for art form to get category
  const findIndx = (art)=>{
    setArt(art);
    updateFilter({ art: art });
    const index = artInfo1.findIndex(item => item.art === art);
    setIndx(index);
  }

  useEffect(() => {
      if(Array.from(searchParams.entries()).length > 0){
        setFilteredProfiles(filteredData);
      }
      else{
        setFilteredProfiles([]);
      }
    },[filteredData])

  // initialize filter state from URL params
  useEffect(() => {
    const params = Object.fromEntries(searchParams.entries());

    setSelectedCategoryName(params.category || '');
    setSelectedSubcategoryName(params.subcategory || '');
    setSelectedArtForm(params.artform || '');
    setSelectedBudget(params.budget || '');
    setSelectedLanguage(params.language || '');
  }, [searchParams.toString()]);
  
  const [showFiltersPopup, setShowFiltersPopup] = useState(false);

  const dataToPaginate = useMemo(() => {
      // Check if any filter is active
      const hasFilters = Array.from(searchParams.values()).some(Boolean);
  
      let paginationdata = hasFilters ? filteredData : data || [];
  
      return paginationdata;
    }, [filteredData, data, searchParams.toString()]);
  
  
    const paginatedData = useMemo(() => {
      const startIndex = (currentPage - 1) * itemsPerPage;
      // const endIndex = startIndex + itemsPerPage;
  
      return dataToPaginate.slice(startIndex, startIndex + itemsPerPage);
    }, [dataToPaginate, currentPage]);
  
  
    const totalPages = Math.ceil(dataToPaginate.length / itemsPerPage);
  
  
    useEffect(() => {
      // const params = new URLSearchParams(searchParams);
      // params.set('page', 1);
      // setSearchParams(params);
    }, [searchParams.toString()]);

    
  const handleSubmit = (e)=>{
    e.preventDefault();
    setFilteredProfiles(filteredData);
    console.log(filteredData)
  }

  return (
    <div className='marketplace-page'>
      <MarketplaceNavbar />
      {/* <div className="marketplace-home">
        <h1 className="marketplace-title">Products</h1> */}


        <div className='products-main'>
          <div style={{
                height:"fit-content",
                backgroundColor:"white"
              }} className='ArtistProfiles_Allfilters'>
          <h5 style={{textAlign:'center', display:'flex', alignItems:'center', gap:'5px', justifyContent:'center'}}>
            <FaFilter />
            All filters
          </h5>
          <div className='ArtistProfiles_Allfilters_form'>
            <form onSubmit={handleSubmit}>
              
              <div className='ArtistProfiles_Allfilters_form_inputfield'>
                <label>Category</label>
                <select value={selectedCategoryName} onChange={handleCategoryChange}>
                  <option value="">-- Select Category --</option>
                  {purpose.map((item) => (
                    <option key={item.category} value={item.category}>
                      {item.category}
                    </option>
                  ))}
                </select>
              </div>
          
              <div className='ArtistProfiles_Allfilters_form_inputfield'>
                <label>Sub Category</label>
                <select 
                  value={selectedSubcategoryName} 
                  onChange={handleSubcategoryChange}
                  disabled={!selectedCategoryName}
                >
                  <option value="">-- Select Subcategory --</option>
                  {currentCategoryObj?.subcategories.map((sub) => (
                    <option key={sub.name} value={sub.name}>
                      {sub.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className='ArtistProfiles_Allfilters_form_inputfield'>
                <label>Art Form</label>
                <select 
                  value={selectedArtForm} 
                  onChange={(e) => { setSelectedArtForm(e.target.value); updateFilter({ artform: e.target.value }); }}
                  disabled={!selectedSubcategoryName}
                >
                  <option value="">-- Select Art Form --</option>
                  {currentSubcategoryObj?.artForms.map((sub) => (
                    <option key={sub} value={sub}>
                      {sub}
                    </option>
                  ))}
                </select>
              </div>
              
              
              <div className='ArtistProfiles_Allfilters_form_inputfield'>
                <label>Budget</label>
                <select value={selectedBudget} onChange={handleBudgetChange}>
                  <option value="" hidden>Select Budget</option>
                  <option value="100-1000">100 - 1000</option>
                  <option value="1000-3500">1000 - 3500</option>
                  <option value="3500-5000">3500 - 5000</option>
                  <option value="5000+">5000 and above</option>
                </select>
              </div>
              <div className='ArtistProfiles_Allfilters_form_inputfield'>
                <label>Language</label>
                <select value={selectedLanguage} onChange={handleLanguageChange}>
                  <option value="" hidden>Select Language</option>
                  {
                    languages.map((item, index)=>{
                      return(
                        <option key={index} value={item}>{item}</option>
                      )
                    })
                  }
                </select>
              </div>

              <div style={{display:'flex', gap:'10px', marginTop:'10px'}}>
                <button
                  type="button"
                  style={{width: '50%', color:'#a40505'}}
                  onClick={()=> {
                    setSearchParams(new URLSearchParams());
                    setSelectedCategoryName('');
                    setSelectedSubcategoryName('');
                    setSelectedArtForm('');
                    setSelectedBudget('');
                    setSelectedLanguage('');
                  }}
                >
                  Reset
                </button>
                <button type='submit' className='filter_btn'>Apply Filters</button>
              </div>

            </form> 
          </div>
          </div> 
        
{paginatedData.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📦</div>
            <h2>No Products Found</h2>
            <p>
              {Array.from(searchParams.values()).some(Boolean)
                ? 'Try adjusting your search or filter criteria'
                : 'No products available at this time'}
            </p>
          </div>
        ) : (


          <div className="marketplace-products-container">
            {paginatedData.map((product) => (
              <div  className="">
                <ProductCard product={product} />
                
              </div> 
              
              
             ))} 
          </div>
          
        )} 
      {/* </div> */}
      </div>
    </div>

  );
};

export default ProductList;